import { useState } from 'react';
import { usePosCancelScheduleMutation } from '../../services/scheduleApi';
export function usePostCancelSchedule() {
    const [trigger] = usePosCancelScheduleMutation();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);
    async function postCancelSchedule(id) {
        setLoading(true);
        setError(false);
        setSuccess(false);
        try {
            await trigger({ id }).unwrap();
            setSuccess(true);
        }
        catch {
            setError(true);
        }
        finally {
            setLoading(false);
        }
    }
    return {
        loading,
        setLoading,
        error,
        setError,
        success,
        setSuccess,
        postCancelSchedule,
    };
}
